import React from 'react'
import { Link } from 'react-router-dom'

export default function SideBarMenu() {
    return (
        <>
            <div className="sidebar_menu" id="target">

                <div className="overlay"></div>
                <button type="button" className="cloase_btns hide_sidebar p-2"><i className="fa fa-times"></i></button>

                <div className="content position-relative">
                    <div className="head">
                        <div className='logo'>
                            <Link to="/">
                                <img src="assets/images/logo/logo.png" />
                            </Link>
                        </div>
                    </div>

                    <div className="accordion" id="category" style={{ paddingLeft: "15px", paddingRight: "15px" }}>

                        <div className="sidebar_menu_list">

                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <Link to="/">
                                        Home
                                    </Link>
                                </h2>
                            </div>

                            <div className="accordion-item">
                                <h2 className="accordion-header" id="rajhansOne">
                                    <a href="#" className="accordion-button collapsed" data-bs-toggle="collapse"
                                        data-bs-target="#raj1" aria-expanded="false" aria-controls="raj1">
                                        Company
                                    </a>
                                </h2>
                                <div id="raj1" className="accordion-collapse collapse" aria-labelledby="rajhansOne"
                                    data-bs-parent="#category">
                                    <div className="accordion-body">
                                        <ul>
                                            <li>
                                                <Link to="/aboutus">
                                                    <i className="fa fa-minus"></i>About Us
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/infrastructure">
                                                    <i className="fa fa-minus"></i>Infrastructure
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/mission-achievements">
                                                    <i className="fa fa-minus"></i>Mission & Achievements
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="accordion-item">
                                <h2 className="accordion-header" id="rajhansTwo">
                                    <a href="#" className="accordion-button collapsed" data-bs-toggle="collapse"
                                        data-bs-target="#raj2" aria-expanded="false" aria-controls="raj2">
                                        Products
                                    </a>
                                </h2>
                                <div id="raj2" className="accordion-collapse collapse" aria-labelledby="rajhansTwo"
                                    data-bs-parent="#category">
                                    <div className="accordion-body">
                                        <ul>
                                            <li>
                                                <Link to="#">
                                                    <i className="fa fa-minus"></i>
                                                    Centerless Grinding Machine
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    <i className="fa fa-minus"></i>
                                                    Cylindrical Grinding Machine
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    <i className="fa fa-minus"></i>
                                                    Internal Grinding Machines
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    <i className="fa fa-minus"></i>
                                                    Angular Grinding Machine
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    <i className="fa fa-minus"></i>
                                                    SPM Grinding Machine
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <Link to="/contactus">
                                        Contact Us
                                    </Link>
                                </h2>
                            </div>

                        </div>
                    </div>

                    <div className="sidebar-contact">
                        <p>Plot No 2212, GIDC Phase IV,<br />Wadhwan City, Surendranagar - 363035</p>
                        <p>
                            <i className='fa fa-phone-volume me-3'></i>
                            <Link to="tel:+919879697447">+91 98796 97447</Link>
                        </p>
                        <p>
                            <i className='fa fa-envelope me-3'></i>
                            <Link to="">omicroncorporate@gmail.com</Link>
                        </p>
                        <p>
                            <i className='fa fa-globe-asia me-3'></i>
                            <Link to="">www.omicrongrind.net</Link>
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}
